import Tag from '../ui/Tag/Tag'
import Button from '../ui/Button/Button'
import { ExternalLinkIcon, GitHubIcon } from '../ui/Icon/Icon'
import styles from './Projects.module.css'

const ProjectCard = ({ project }) => {
  const { name, description, stack, sourceCode, livePreview, featured } = project
  const primaryLink = livePreview || sourceCode

  return (
    <article className={`${styles.card} ${featured ? styles.featured : ''}`.trim()}>
      <div className={styles.cardHeader}>
        {featured && <span className={styles.badge}>Featured</span>}

        <h3 className={styles.name}>
          {primaryLink ? (
            <a
              href={primaryLink}
              className={styles.nameLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {name}
            </a>
          ) : (
            name
          )}
        </h3>
      </div>

      <p className={styles.description}>{description}</p>

      {stack?.length > 0 && (
        <ul className={styles.stack}>
          {stack.map((tech) => (
            <Tag key={tech}>{tech}</Tag>
          ))}
        </ul>
      )}

      <div className={styles.links}>
        {sourceCode && (
          <Button
            href={sourceCode}
            variant="icon"
            size="sm"
            aria-label={`${name} source code on GitHub`}
            title="Source code"
          >
            <GitHubIcon size={18} />
          </Button>
        )}

        {livePreview && (
          <Button
            href={livePreview}
            variant="icon"
            size="sm"
            aria-label={`${name} live preview`}
            title="Live preview"
          >
            <ExternalLinkIcon size={18} />
          </Button>
        )}
      </div>
    </article>
  )
}

export default ProjectCard
